const SELECTORS = {
    block: '.wp-block-ssm-product-feed',
    label: '.fs-label',
    select: '.facetwp-dropdown',
    facetwpFselect: '.facetwp-type-fselect',
};

export function initProductFeedFacetsPlaceholder(block) {
    const labels = block.querySelectorAll('.fs-label-wrap'); // or '.fs-wrap'

    const cleanups = [];

    if (labels?.length === 0) return () => {};

    labels.forEach((label) => {
        const fsWrap = label.closest('.fs-wrap');
        const select = fsWrap?.querySelector('.fs-dropdown');
        
        if (!select) return;
        
        const onWrapClick = (e) => {
            e.preventDefault();
            select.classList.toggle('fs-hidden');
        };
        
        fsWrap.addEventListener('click', onWrapClick);
        cleanups.push({ element: fsWrap, handler: onWrapClick });
    });

    return () => {
        cleanups.forEach(({ element, handler }) => {
            element.removeEventListener('click', handler);
        });
    };
}

export function initProductFeed(block) {
    // show 0 in fs-label when no selections
    document.addEventListener('facetwp-loaded', function () {
        document.querySelectorAll(SELECTORS.facetwpFselect).forEach(function (facet) {
            const facetName = facet.dataset.name;
            const label = facet.querySelector(SELECTORS.label);
            const select = facet.querySelector(SELECTORS.select);

            if (label && select && FWP.facets[facetName]) {
                // Check if no selections are made
                if (!FWP.facets[facetName] || FWP.facets[facetName].length === 0) {
                    // Get the default label text (without any existing span)
                    const defaultLabel = label.textContent.replace(/\s*\d+\s*$/, '').trim();
                    // Add span with 0
                    label.innerHTML = defaultLabel + ' <span class="fs-label__number">0</span>';
                }
            }
        });
    });
}

export function productFeed() {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initProductFeed(block);
    });
}
